@if (vm$ | async; as vm) {
  <ng-container *transloco="let t; read: 'revisions'">
    <div class="componentContainer">
      <section class="xs12col componentHeader">
        <h1>{{t('title')}}</h1>
      </section>
      <section class="oneCol">
        <div class="xs12col">
          <div class="boxContainer">
            <div class="box">
              <h2 class="padding-bottom-medium">{{t('searchTitle')}}</h2>
              <form
                [formGroup]="filterForm"
                (ngSubmit)="onSubmit(vm.searchRequest)"
                class="searchForm">
                <kendo-formfield class="xs12col m6col">
                  <kendo-label [text]="t('company')"></kendo-label>
                  <kendo-dropdownlist
                    [data]="vm.companies"
                    textField="name"
                    valueField="id"
                    [defaultItem]="{ id: null, name: t('chooseClient') }"
                    [kendoDropDownFilter]="filterSettings"
                    formControlName="companyId"
                    class="xs12col"
                    [valuePrimitive]="true">
                  </kendo-dropdownlist>
                </kendo-formfield>
                <kendo-formfield class="xs12col m6col">
                  <kendo-label [text]="t('revisionStatus')"></kendo-label>
                  <kendo-multiselect
                    [data]="vm.revisionStatus"
                    textField="name"
                    valueField="id"
                    formControlName="revisionStatusIds"
                    [valuePrimitive]="true">
                  </kendo-multiselect>
                </kendo-formfield>
                <kendo-daterange class="xs12col m6col">
                  <kendo-label [text]="t('executionDate')"  class="label"></kendo-label>
                  <kendo-dateinput
                    kendoDateRangeStartInput
                    formControlName="executionDateFrom"
                    [placeholder]="t('placeholderFrom')"
                  ></kendo-dateinput>
                  <kendo-dateinput
                    kendoDateRangeEndInput
                    formControlName="executionDateTo"
                    [placeholder]="t('placeholderTo')"
                  ></kendo-dateinput>
                </kendo-daterange>
                <kendo-formfield class="xs12col m6col">
                  <div class="searchInputContainer">
                    <span  class="tooltipContainer">
                      <kendo-label [text]="t('keyword')"></kendo-label>
                      <span [attr.tooltip]="t('tooltipSearch')" flow="right" class="tooltipContainer">
                        <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                      </span>
                    </span>
                    <kendo-textbox
                      formControlName="keyword" class="searchTextField">
                    </kendo-textbox>
                  </div>
                </kendo-formfield>
                <div class="buttonContainer">
                  <button
                    type="button"
                    (click)="resetFilter()"
                    class="buttonSecondary">
                    {{ t('resetFilter') }}
                  </button>
                </div>
              </form>
              <kendo-grid
                [data]="vm.revisions"
                [skip]="vm.gridState.skip"
                [pageSize]="vm.gridState.pageSize"
                [pageable]="true"
                [loading]="loading"
                (pageChange)="pageChangeSub$.next($event)">
                @if (('Permissions.Revisions.Create' | permission)) {
                  <ng-template kendoGridToolbarTemplate>
                    <a kendoGridAddCommand [routerLink]="['new']" class="addIcon">
                      <span class="icon">
                        <img src="../../../assets/icons/add-icon.svg">
                      </span>
                      <span>{{t('add')}}</span>
                    </a>
                  </ng-template>
                }
                <!-- DESKTOP GRID -->
                <kendo-grid-column field="companyId" [title]="t('company')" media="(min-width: 993px)">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.company?.name}}
                  </ng-template>
                  <ng-template
                    let-isNew="isNew"
                    let-formGroup="formGroup">
                    <kendo-textbox
                      [formControl]="formGroup.get('companyId')"
                    ></kendo-textbox>
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="orderNumber" [title]="t('orderNumber')" media="(min-width: 993px)">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.orderNumber || '-' }}
                  </ng-template>
                  <ng-template  let-formGroup="formGroup">
                    <kendo-textbox [formControl]="formGroup.get('orderNumber')"></kendo-textbox>
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="executionDateFrom" [title]="t('scheduledDate')" media="(min-width: 993px)">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    {{sanitizeCreationDate(dataItem.scheduledDate)}}
                  </ng-template>
                  <ng-template let-formGroup="formGroup">
                    <kendo-textbox [formControl]="formGroup.get('executionDateFrom')"></kendo-textbox>
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="revisionStatusId" [title]="t('revisionStatus')" media="(min-width: 993px)">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.revisionStatus?.name || '-' }}
                  </ng-template>
                  <ng-template  let-formGroup="formGroup">
                    <kendo-textbox [formControl]="formGroup.get('revisionStatusId')"></kendo-textbox>
                  </ng-template>
                </kendo-grid-column>
                <!-- MOBILE GRID -->
                <kendo-grid-column media="(max-width: 992px)">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <h4 class="mobileGridHeader">{{t('company')}}</h4>
                    <span>{{dataItem.company?.name}}</span>
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column media="(max-width: 992px)">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <h4 class="mobileGridHeader">{{t('orderNumber')}}</h4>
                    <span>{{dataItem.orderNumber || '-' }}</span>
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column media="(max-width: 992px)">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <h4 class="mobileGridHeader">{{t('scheduledDate')}}</h4>
                    <span>{{sanitizeCreationDate(dataItem.scheduledDate)}}</span>
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column media="(max-width: 992px)">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <h4 class="mobileGridHeader">{{t('revisionStatus')}}</h4>
                    <span>{{dataItem.revisionStatus?.name || '-' }}</span>
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-command-column>
                  <ng-template
                    kendoGridCellTemplate
                    let-isNew="isNew"
                    let-dataItem>
                    <a
                      [routerLink]="[dataItem.id]"
                      [attr.tooltip]="t('open')"
                      flow="up"
                      class="actionIcon">
                      <img src="../../../assets/icons/open-link-icon.svg">
                    </a>
                  </ng-template>
                </kendo-grid-command-column>
                <!-- Paging -->
                <ng-template
                  let-totalPages="totalPages"
                  let-currentPage="currentPage"
                  kendoPagerTemplate>
                  <div class="flex flexRow gridPagination xs12col flex-wrap">
                    <div class="flex flexDirRow gridRow">
                      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                      <kendo-pager-numeric-buttons
                        [buttonCount]="5"
                      ></kendo-pager-numeric-buttons>
                      <kendo-pager-next-buttons></kendo-pager-next-buttons>
                    </div>
                    <div class="gridRow">
                      <kendo-buttongroup [selection]="'single'" id="pageBtnGroup">
                        <button
                                (click)="pageChangeSub$.next({
                                  skip: vm.gridState.skip,
                                  take: pageSizes.Small
                                })"
                          kendoButton
                          [selected]="vm.gridState.pageSize === pageSizes.Small"
                          [toggleable]="true"
                          >
                          {{ pageSizes.Small }}
                        </button>
                        <button
                                (click)="pageChangeSub$.next({
                                  skip: vm.gridState.skip,
                                  take: pageSizes.Medium
                                })"
                          kendoButton
                          [selected]="vm.gridState.pageSize === pageSizes.Medium"
                          [toggleable]="true"
                          >
                          {{ pageSizes.Medium }}
                        </button>
                        <button
                                (click)="pageChangeSub$.next({
                                  skip: vm.gridState.skip,
                                  take: pageSizes.Large
                                })"
                          kendoButton
                          [selected]="vm.gridState.pageSize === pageSizes.Large"
                          [toggleable]="true"
                          >
                          {{ pageSizes.Large }}
                        </button>
                      </kendo-buttongroup>
                      @if (reloadResults) {
                        <button
                          kendoButton
                          [title]="t('refresh')"
                          class="reloadIcon"
                          (click)="searchRequest$.next(vm.searchRequest)">
                          <img class="actionIcon" src="../assets/icons/reload.svg">
                        </button>
                      }
                    </div>
                  </div>
                </ng-template>
                <!-- NO RESULTS FOUND-->
                <ng-template kendoGridNoRecordsTemplate>
                  <div class="text pl">{{t('noResults')}}</div>
                </ng-template>
                <ng-template kendoGridLoadingTemplate>
                  <div class="k-loading-color"></div>
                  <div class="loading-container">
                    <kendo-loader type="converging-spinner" size="large"></kendo-loader>
                  </div>
                </ng-template>
              </kendo-grid>
            </div>
          </div>
        </div>
      </section>
    </div>
  </ng-container>
}